import { render } from "./ThemeSettingsOverview.vue?vue&type=template&id=6bc6c499&scoped=true&ts=true"
import script from "./ThemeSettingsOverview.vue?vue&type=script&lang=ts"
export * from "./ThemeSettingsOverview.vue?vue&type=script&lang=ts"

import "./ThemeSettingsOverview.vue?vue&type=style&index=0&id=6bc6c499&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc6c499"]])

export default __exports__